/* eslint-disable no-continue */
import * as marietta from '../..';
import { BUILDING_TYPE_MANSION, CONTROL_ACTIONMODE } from '../Constants';
import { SVGSprite } from '../flash/display';
import { Stage } from '../model';
import MonicaObject from './MonicaObject';
import { ItemControllerWallObject } from '../control';

export default class WallObject extends MonicaObject {
  lockView: SVGElement;

  wallView: SVGElement;

  wallObjList: marietta.webcad.item.parts.Wall[];

  dummyWallView: SVGElement;

  guideView: SVGElement;

  wallGuideList: marietta.webcad.item.parts.WallGuide[];

  /**
   * リドロー
   */
  reCreateImage = () => {
    // 削除する
    this.wallView.remove();
    this.guideView.remove();
    this.dummyWallView.remove();
    this.createImage();
  }

  /**
   * ビューの作成
   */
  createImage() {
    let viewObj: Element;
    if (this.spt === undefined) {
      viewObj = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    } else {
      viewObj = this.spt.element;
    }
    viewObj.setAttribute('d', marietta.webcad.util.SVGUtil.getPathString(this.itemInfo.dotList));
    viewObj.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.guid}`);
    // 壁
    this.wallObjList = [];
    this.wallGuideList = [];
    this.wallView = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    this.wallView.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.guid}wallGroup`);

    const wallPointListDummy: marietta.core.Point[] = [];

    // 生成
    const wall: marietta.webcad.item.parts.Wall = new marietta.webcad.item.parts.Wall(0, this.wallView, this.itemInfo.dotList[0], this.itemInfo.dotList[1], 'square');
    // 壁情報がなければ、デフォルトを指定する
    if (this.itemInfo.dotList[0].wall_type === undefined || Number.isNaN(this.itemInfo.dotList[0].wall_type)) {
      // this.itemInfo.dotList[0].wall_type = WebCADConfig.WALL_TYPE_ALLWALL;
      this.itemInfo.dotList[0].wall_type = 1;
    }
    wall.wallType = this.itemInfo.dotList[0].wall_type;
    // 壁高さ情報を設定
    // if (this.itemInfo.dotList[0].wall_height !== undefined || !isNaN(this.itemInfo.dotList[0].wall_height)) {
    //   wall.wallHeight = this.itemInfo.dotList[0].wall_height;
    // }
    let gpt = marietta.webcad.util.WebCADUtil.createPolygonLine([this.itemInfo.dotList[0].point, this.itemInfo.dotList[1].point], 40);
    if (this.itemInfo.dotList[0].point.x > this.itemInfo.dotList[1].point.x) {
      gpt = marietta.webcad.util.WebCADUtil.createPolygonLine([this.itemInfo.dotList[1].point, this.itemInfo.dotList[0].point], 40);
    }
    wall.parentObj = this;
    wall.parentObjInfo = this.itemInfo;

    this.wallObjList.push(wall);
    viewObj.appendChild(this.wallView);

    this.guideView = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    this.guideView.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.guid}wallGuide`);
    wallPointListDummy.push(this.itemInfo.dotList[0].point.clone());

    const guide: marietta.webcad.item.parts.WallGuide = new marietta.webcad.item.parts.WallGuide(this.guideView, 0);
    if (gpt && gpt.length > 1) {
      guide.firstDot = gpt[0].clone();
      guide.secondDot = gpt[1].clone();
    }
    guide.parentObj = this;
    this.wallGuideList.push(guide);
    viewObj.appendChild(this.guideView);

    // 穴を埋めるダミー壁
    if (this.dummyWallView !== undefined) this.dummyWallView.remove();
    this.dummyWallView = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    this.dummyWallView.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.guid}wallGroupDummy`);
    let dummyWallObj: SVGElement;
    let maeDot: marietta.webcad.collection.PointCollection;
    let atoDot: marietta.webcad.collection.PointCollection;
    let nextPoint: marietta.core.Point;
    let dot1: marietta.core.Point;
    let dot2: marietta.core.Point;
    let scale: number;
    let points: marietta.core.Point[] = [];
    let wallColor;
    let hasNaN: boolean;
    for (let i: number = 0; i < this.itemInfo.dotList.length; i += 1) {
      points = [];
      // 前後の壁
      maeDot = (i === 0) ? this.itemInfo.dotList[this.itemInfo.dotList.length - 1] : this.itemInfo.dotList[i - 1];
      atoDot = (i === this.itemInfo.dotList.length - 1) ? this.itemInfo.dotList[0] : this.itemInfo.dotList[i + 1];
      wallColor = marietta.webcad.WebCADGlobal.getColorForWallType(this.itemInfo.dotList[i].wall_type);

      // どちらかも壁じゃないときは次
      if (this.itemInfo.dotList[i].wall_type < 1) continue;

      // guid付与
      if (!this.itemInfo.dotList[i].guid) {
        this.itemInfo.dotList[i].guid = marietta.webcad.WebCADGlobal.getGuid();
      }

      // 前の壁
      dot1 = new marietta.core.Point(maeDot.x, maeDot.y);
      dot2 = new marietta.core.Point(this.itemInfo.dotList[i].x, this.itemInfo.dotList[i].y);
      scale = ((marietta.core.Point.distance(dot1, dot2) - 5) / marietta.core.Point.distance(dot1, dot2));
      nextPoint = marietta.core.Point.interpolate(dot1, dot2, scale);
      points.push(new marietta.core.Point(nextPoint.x, nextPoint.y));
      points.push(new marietta.core.Point(this.itemInfo.dotList[i].x, this.itemInfo.dotList[i].y));
      if (scale === Infinity) continue;

      dot1 = new marietta.core.Point(this.itemInfo.dotList[i].x, this.itemInfo.dotList[i].y);
      dot2 = new marietta.core.Point(atoDot.x, atoDot.y);
      scale = (5 / marietta.core.Point.distance(dot1, dot2));
      nextPoint = marietta.core.Point.interpolate(dot1, dot2, scale);
      points.push(new marietta.core.Point(nextPoint.x, nextPoint.y));
      if (scale === Infinity) continue;
      hasNaN = false;
      for (let k: number = 0; k < points.length; k += 1) {
        if (Number.isNaN(points[k].x) || Number.isNaN(points[k].y)) {
          hasNaN = true;
          break;
        }
      }
      if (hasNaN) continue;

      dummyWallObj = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      dummyWallObj.setAttribute('d', marietta.webcad.util.SVGUtil.getPathString(points));
      dummyWallObj.setAttribute('stroke', wallColor.color);
      dummyWallObj.setAttribute('opacity', wallColor.alpha);
      dummyWallObj.setAttribute('stroke-width', '10');
      dummyWallObj.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.index}wallGroupDummy_${i}`);
      this.dummyWallView.appendChild(dummyWallObj);
    }
    viewObj.appendChild(this.dummyWallView);

    if (this.spt === undefined) {
      this.spt = new SVGSprite(viewObj);
      this.spt.x = this.itemInfo.x;
      this.spt.y = this.itemInfo.y;
      this.spt.update();
    }

    // 表示モードの更新
    //   this.updateWallViewMode();
    this.showHideWallGuide(false);
  }

  /**
   * マウスダウンされた
   * @param e
   */
  onMouseDownMe = (e: MouseEvent & TouchEvent) => {
    // ウォールガイドのテキストボックスを削除
    if (this instanceof marietta.webcad.item.Room) {
      if ((e.target as HTMLElement).id !== 'guideText') {
        for (let i = 0; i < this.wallGuideList.length; i += 1) {
          this.wallGuideList[i].removeTextBoxObj();
        }
      }
    }

    if (marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
      if ((<TouchEvent>e).touches.length > 1) {
        return;
      }

      Stage.refreshStageMouse(<TouchEvent>e);
    }

    // 選択モードのときは、バブリングさせない
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode === CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM) {
      e.stopPropagation();
    }

    if (!marietta.webcad.WebCADGlobal.layerGroup.itemEnabled) {
      // カレントをなくす
      marietta.webcad.WebCADGlobal.itemManager.currentItem = null;
      marietta.webcad.WebCADGlobal.itemManager.currentItemGroup = null;
      return;
    }

    // カレントの設定
    e.preventDefault();

    //   if (marietta.webcad.WebCADGlobal.itemManager.currentItem instanceof marietta.webcad.item.Fitting) {
    //     marietta.webcad.WebCADGlobal.itemManager.currentItem.isSelected = false;
    //   }

    // カレントに設定
    // @ts-ignore
    marietta.webcad.WebCADGlobal.itemManager.currentItem = this;
  }

  /**
   * マウス移動
   * @private
   */
  protected onMouseMoveHandler(): void {
    // 移動しない
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType !== BUILDING_TYPE_MANSION) {
      super.onMouseMoveHandler();
    }
  }

  /**
   * 距離テキスト ボックスへの入力に関する項目を更新する
   * @param newDistance
   * @param direction
   */
  updateItemWithInput(newDistance: number, index: number): void {
    if (this.itemInfo.lock) return;
    const distInPix = marietta.webcad.util.WebCADUtil.convertMMToPix(newDistance);
    let originIndex = 0;
    if (marietta.webcad.WebCADGlobal.itemManager.itemController && marietta.webcad.WebCADGlobal.itemManager.itemController.selectedPicker != null) {
      originIndex = ((<ItemControllerWallObject>marietta.webcad.WebCADGlobal.itemManager.itemController).selectedPicker).index - 1;
    }
    const endIndex = originIndex === 0 ? 1 : 0;
    const startPoint = this.wallObjList[0].parentObj.itemInfo.dotList[originIndex].point;
    const endPoint = this.wallObjList[0].parentObj.itemInfo.dotList[endIndex].point;
    const newPoint = marietta.webcad.util.WebCADUtil.findPointAlongLine(startPoint, endPoint, distInPix);
    this.itemInfo.dotList[endIndex] = new marietta.webcad.collection.PointCollection(newPoint.x, newPoint.y);
    this.reCreateImage();
    marietta.webcad.WebCADGlobal.itemManager.currentItem = null;
    marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
  }

  /**
* 削除
* */
  deleteMe(deferredObj: any = null) {
    super.deleteMe(deferredObj);
    marietta.webcad.WebCADGlobal.webcad2Dmanager.updateWallList();
  }

  /**
   * 移動 XY
   */
  move(x: number, y: number) {
    const xDiff = x - this.itemInfo.x;
    const yDiff = y - this.itemInfo.y;
    for (let i = 0, len = this.itemInfo.dotList.length; i < len; i += 1) {
      this.itemInfo.dotList[i].x += xDiff;
      this.itemInfo.dotList[i].y += yDiff;
    }
    this.reCreateImage();
  }

  /**
   * 頂点XMLの取得
   */
  getPointXML(): Element[] {
    const pointNodeList = [];
    let pointNode;
    let localPoint: any;

    for (let i = 0, len = this.itemInfo.dotList.length; i < len; i += 1) {
      pointNode = document.createElementNS(null, 'point');
      pointNode.setAttribute('index', String(i + 1));

      localPoint = new marietta.core.Point(this.itemInfo.dotList[i].x, this.itemInfo.dotList[i].y);
      localPoint = this.spt.localToGlobal(localPoint);
      pointNode.setAttribute('x', String(Math.round(localPoint.x / marietta.webcad.WebCADGlobal.scaleSize)));
      pointNode.setAttribute('wall_type', this.itemInfo.dotList[i].wall_type);
      pointNode.setAttribute('y', String(-Math.round(localPoint.y / marietta.webcad.WebCADGlobal.scaleSize - marietta.webcad.WebCADGlobal.LAYER_SIZE_H)));
      pointNodeList.push(pointNode);
    }
    return pointNodeList;
  }

  /**
* Scaling wall guide
*/
  updateWallGuide() {
    this.wallGuideList.forEach((wall: marietta.webcad.item.parts.WallGuide) => {
      wall.updateTransforms();
    });
  }

  /**
   * 頂点情報の回転
   */
  rotateDots(value: number): void {
    const r: number = ((value % 360) / 180) * Math.PI;
    let p1: marietta.core.Point;
    let xx: number;
    let yy: number;

    for (let i: number = 0; i < this.itemInfo.dotList.length; i += 1) {
      p1 = this.itemInfo.dotList[i].point;
      xx = p1.x * Math.cos(r) - p1.y * Math.sin(r);
      yy = p1.x * Math.sin(r) + p1.y * Math.cos(r);
      this.itemInfo.dotList[i].x = xx;
      this.itemInfo.dotList[i].y = yy;
    }

    this.reCreateImage();
  }

  /**
 * 壁のワイヤービュー
 * @param value
 */
  // updateWallViewMode() {
  // //   for (let i: number = 0; i < this.wallObjList.length; i++) {
  // //     this.wallObjList[i].updateWallViewMode();
  // //   }
  // }

  /**
  * ドットを反転する
  */
  flipDots(): void {
    let i: number;

    // 左上が原点になるように、コンバートしておく
    // Ｘ座標をマイナスにする
    let minX: number;
    for (i = 0; i < this.itemInfo.dotList.length; i += 1) {
      this.itemInfo.dotList[i].x *= -1;
      if (this.itemInfo.dotList[i].x < minX || minX === undefined || minX === null) minX = this.itemInfo.dotList[i].x;
    }

    // 左上原点になるよう修正
    for (i = 0; i < this.itemInfo.dotList.length; i += 1) {
      this.itemInfo.dotList[i].x += 0 - minX;
    }
    this.itemInfo.x -= minX;

    this.reCreateImage();
  }

  showHideWallGuide(value: boolean) {
    if (value) this.guideView.style.display = 'block';
    else this.guideView.style.display = 'none';
  }
}
